import { render, staticRenderFns } from "./BpDataTableField.vue?vue&type=template&id=26e2d26a&scoped=true&"
import script from "./BpDataTableField.vue?vue&type=script&lang=js&"
export * from "./BpDataTableField.vue?vue&type=script&lang=js&"
import style0 from "./BpDataTableField.vue?vue&type=style&index=0&id=26e2d26a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e2d26a",
  null
  
)

export default component.exports